import "./footer.component.css";
import footerGirlPhoto from "../../assets/footer-girl.png";
import footerFlowerPhoto from "../../assets/footer-flower.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { NavLink } from "../navbar/navbar.component";

function Footer() {
  return (
    <div className="w-100 d-flex flex-column">
      <div className="d-flex padding-v-15 padding-h-40 no-padding-left sub-back-1 pe-md-0 col-12 justify-content-center-md justify-content-space-between px-3">
        <div className="d-flex col-sm-5 col-md-5 col-lg-8 col-xl-7 justify-content-end align-items-center padding-v-40 no-padding-top pb-md-0">
          <div className="d-flex flex-column h-100 justify-content-space-between justify-content-center-lg">
            <div
              className="d-flex justify-content-center padding-v-30 no-padding-bottom pt-md-0"
              id={NavLink.SOCIALS}
            >
              <FontAwesomeIcon
                icon={faEnvelope}
                className="social-icon sub-font-1 margin-10 no-margin-right cursor"
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/in/tshepiso-motsumi-839894192/",
                    "_blank"
                  );
                }}
              />
              <FontAwesomeIcon
                icon={faLinkedin}
                className="social-icon sub-font-1 margin-v-15 margin-10 cursor"
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/in/tshepiso-motsumi-839894192/",
                    "_blank"
                  );
                }}
              />
            </div>
            <div className="sub-font-1 font-bold fs-6 text-center">
              Created By God To Create.
            </div>
          </div>
          <div className="d-flex h-100 align-items-end-md align-items-center-lg">
            <img
              className="flower-image"
              src={footerFlowerPhoto}
              alt="flower footer"
            />
          </div>
        </div>
        <div className="d-flex col-sm-7 col-md-7 col-lg-4 col-xl-5 justify-content-end footer-girl-cover">
          <img className="footer-girl" src={footerGirlPhoto} alt="footer" />
        </div>
      </div>
      <div className="d-flex justify-content-space-evenly align-items-center padding-v-20 px-3 text-center">
        <div className="font-italic fs-6 font-light">
          Empathy. Design. Impact.
        </div>
        <div className="font-italic fs-6 font-light">All Rights Reserved. </div>
      </div>
    </div>
  );
}

export default Footer;
